<template>
  <div>
    <div class="fixed_page"  id="blurry">
      <div class="get-started_home">
        <a style="cursor: pointer" @click.prevent="goToStarsPage" v-if="!hideExchangeStars">
          <div class="stars_section">
            <div class="stars_inside">
              <div class="stars_icon"><img src="static/images/star.svg" alt="" class=""></div>
              <div class="stars_count"><p>{{ userDetails.stars }}</p></div>
            </div>
          </div>
        </a>
        <main class="home-main">
          <div class="fixed_page">
            <div class="main_home_box">
              <div class="main_home_box main_titles">
                <h1>{{ getTranslations.home_main_titles_title }}</h1>
                <p>{{ getTranslations.home_main_titles_text0 }}</p>
                <p>{{ getTranslations.home_main_titles_text1 }} </p>
              </div>

            <carousel></carousel>

            <div class="main_home_btns">
              <div class="button" @click.prevent="openUnlockedModal"><a style="cursor: pointer" class="unlocked_games"><img src="static/images/ball.svg" alt=""><span>{{ getTranslations.home_games_left }}  {{ userDetails.availableGames }}</span></a></div>
              <div v-if="!hideStore" @click.prevent="toStorePage" class="button">
                <a  style="cursor: pointer"  class="unlocked_games">
                  <img src="static/images/basket.svg" alt=""><span>{{ getTranslations.home_buy_games }}</span></a>
              </div>
              <div class="button" @click="playGame"><a style="cursor: pointer" class="play_game"> {{ getTranslations.home_play_game }} </a></div>
            </div>
          </div>

        <div v-if="facebookFunctionality" class="facebook_connect_box">
          <div class="facebook_connect_inside">
            <div class="facebook_icon"><img src="static/images/icon-FB.svg"></div>
            <div class="facebook_text"><p> {{ getTranslations.visitor_facebook_login_connect_before_points }}
              {{ getTranslations.visitor_facebook_login_connect_before_points_to_earn }}
              {{ connectionPoints }} {{ getTranslations.visitor_facebook_login_connect_after_points }}</p></div>
          </div>
        </div>
        <div class="info_box">

          <div class="col-lg-12">
            <div class="info_box_inside">
              <img src="static/images/icon-info-XL.svg">
              <p>{{ getTranslations.home_infobox_stay_upto_date }}</p>
            </div>

            <div class="" v-if="!!phaseBonusList.length">
                <span v-for="(phase,index) in phaseBonusList" :key="index">
                  <bonus-box :phase=phase @openModal="openModal(phase)" :index="index"></bonus-box>
                </span>
            </div>
          </div>
        </div>
        <div class="pattern_background">

          <div v-if="optaEnabled" class="col-lg-12">
            <div class="placeholder_opt">
              <h1>{{ getTranslations.home_opta_upcoming_matches }}</h1>
            </div>
            <div class="placeholders">
            </div>
            <div> </div>

          </div>
        </div>
      </div>
    </main>
    <footer class="footer-main">
      <div class="containers">
        <nav class="footer-nav">
          <ul class="footer-nav__list">
            <li>
              <a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')" target="_blank">{{ getTranslations.visitor_t_and_c }}</a>
            </li>
            <li>
              <a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_privacy_and_policy')" target="_blank">{{ getTranslations.visitor_visitor_privacy_policy }}</a>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  </div>
      <div class="bonus_phase_outer" v-if="showOptOutPhase">
        <div class="bonus_phase promo_phase_fp" id="optout">
          <div class="bonus_phase_inner ">
            <div class="promo_phase_outer">
              <div class="bonus_phase_content promo_phase_fp">
                <p> {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'home_page_optout_banner_message') }} <a class="optout__link" @click.prevent="goToEditProfile">{{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'home_page_optout_banner_click_here') }}</a></p>
              </div>
            </div>
          </div>
          <button class="bonusclose"  id="bonusclose" @click="closeBannerForOptout()"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint no-console: "off" */
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import modals from '@/common/modals';
import { closeBanner } from '@/common/jQuery';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';
import Carousel from './Carousel';
import UnlockedGamesModal from './modals/unlockedgames/UnlockedGamesModal';
import UnlockedGamesZeroBalanceModal from './modals/unlockedgames/UnlockedGamesZeroBalanceModal';
import BonusBox from './BonusBox';
import BonusDaily from './modals/bonus_phases/BonusDaily';
import BonusMultiplier from './modals/bonus_phases/PointsMultiplier';
import BundleDiscount from './modals/bonus_phases/BundleDiscount';

export default {
  name: 'default-content',
  props: ['playGame'],
  components: {
    Carousel,
    BonusBox,
    UnlockedGamesZeroBalanceModal,
    UnlockedGamesModal,
    BonusDaily,
    BonusMultiplier,
    BundleDiscount,
  },
  mixins: [NumbersFormattingMixin],
  beforeDestroy() {
    this.setBonusPhasesNum(this.phaseBonusList.length);
  },
  mounted() {
    closeBanner();
  },
  methods: {
    ...mapActions('profile', [
      'setMatchInfo',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapMutations('profile', [
      'setBonusPhasesNum',
      'updatePhaseBonusModalToBeDisplayed',
    ]),
    goToStarsPage() {
      this.$router.push('/home/exchangeStars');
    },
    openUnlockedModal() {
      if (this.userDetails.availableGames !== 0) this.storeModalForHomePage(UnlockedGamesModal);
      else this.storeModalForHomePage(UnlockedGamesZeroBalanceModal);
      modals.showHideModal(this);
    },
    goToEditProfile() {
      this.$router.push('/home/profile/edit');
    },
    toStorePage() {
      this.$router.push('/home/store');
    },
    closeBannerForOptout() {
      closeBanner();
    },
    navigateToGameIntro(game) {
      // this.storeModalForHomePage(PreGameModal);
      this.updateGameType(game);
      modals.showHideModal(this);
    },
    openModal(phase) {
      switch (phase.type) {
      case 'BONUS_DAILY':
        this.storeModalForHomePage(BonusDaily);
        break;
      case 'BUNDLES':
        this.storeModalForHomePage(BundleDiscount);
        break;
      default:
        this.storeModalForHomePage(BonusMultiplier);
        break;
      }
      this.updatePhaseBonusModalToBeDisplayed(phase);
      modals.showHideModal(this);
    },
  },
  computed: {
    ...mapState('common', [
      'hideExchangeStars',
      'userDetails',
      'showOptOutPhase',
      'connectionPoints',
      'facebookFunctionality',
      'optaEnabled',
      'hideStore',
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
      'getTranslationByOperator',
    ]),
    ...mapState('profile', [
      'phaseBonusList',
      'bonusPhasesNum',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/DefaultContent.vue